import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MasonryLayoutComponent } from './masonry-layout.component'; 

@NgModule({
    declarations: [
        MasonryLayoutComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        MasonryLayoutComponent
    ],
    entryComponents: [
        MasonryLayoutComponent
    ]
})
export class MasonryLayoutModule { }
